<!--
 * @Description: 
 * @Date: 2020-11-10 16:47:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-27 18:36:50
-->
<template>
  <div class="custom-bar" :class="{ long: isLongText }">
    <div class="custom-bar-item">
      <div
        class="custom-bar-item-block"
        v-for="(item, index) in barArr"
        :key="index"
      >
        <svg
          class="svg"
          :width="barFontWidthTotal"
          :height="barHeight"
          :viewport="`0 0 ${barFontWidthTotal} ${barHeight}`"
          @mouseenter="$set(barHover, index, true)"
          @mouseleave="$set(barHover, index, false)"
        >
          <polygon
            v-if="dealseries0data[index]['value'] != finalDataCount"
            :points="
              `0,0 ${barFontWidthTotal},0 ${barFontWidthTotal},${barHeight} 0,${barHeight} `
            "
            fill="#DBE1E7"
          />
          <g v-if="dealseries0data[index]['value'] > 0">
            <polygon
              :points="cItem.join(' ')"
              v-for="(cItem, cIndex) in item"
              :key="cIndex"
              :fill="
                cIndex == 2
                  ? darkColorArr[index % 6](barHover[index] ? 0.8 : 1)
                  : colorArr[index % 6](
                      [0.8, 1, 1, 0.5][cIndex] - (barHover[index] ? 0.2 : 0)
                    )
              "
            />
          </g>
        </svg>
        <div class="name">{{ dealseries0data[index]['name'] }}</div>
        <div class="value">{{ dealseries0data[index]['value'] }}{{ unit }}</div>
      </div>
    </div>
    <Table :table="table" :normalTable="table && table.isNormal"></Table>
  </div>
</template>

<script>
import { colorArr, darkColorArr } from '../color/config.js';
import Table from '../Table';
export default {
  props: {
    series0data: {
      type: Array,
      default: () => []
    },
    finalDataCount: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: '单'
    },
    table: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  components: { Table },
  data() {
    return {
      colorArr,
      darkColorArr,
      barHover: [],
      barArr: [],
      barFontWidth: [4, 20, 6],
      barHeight: 160,
      isLongText: false
    };
  },
  methods: {
    getBar(value, total) {
      const { barFontWidth } = this;
      const barHeight = (value / total) * this.barHeight - 6;
      // const sinFor60 = Math.sin(Math.PI / 3);
      const cosFor45 = Math.cos((Math.PI * 45) / 180);
      const xArr = barFontWidth.reduce(
        (pre, cur) => {
          pre.total += cur;
          pre.arr.push(pre.total);
          return pre;
        },
        {
          total: 0,
          arr: [0]
        }
      ).arr;
      const bottomPoint1 = [xArr[0], this.barHeight];
      const bottomPoint2 = [xArr[1], this.barHeight];
      const bottomPoint3 = [xArr[2], this.barHeight];
      const bottomPoint4 = [xArr[3], this.barHeight];
      const topPoint1 = [xArr[0], this.barHeight - barHeight];
      const topPoint2 = [xArr[1], this.barHeight - barHeight];
      const topPoint3 = [xArr[2], this.barHeight - barHeight];
      const topPoint4 = [
        xArr[3],
        this.barHeight - barHeight - barFontWidth[2] / cosFor45
      ];
      const topPoint5 = [
        barFontWidth[2],
        this.barHeight - barHeight - barFontWidth[2] / cosFor45
      ];
      return [
        [...topPoint1, ...topPoint2, ...bottomPoint2, ...bottomPoint1],
        [...topPoint2, ...topPoint3, ...bottomPoint3, ...bottomPoint2],
        [...topPoint3, ...topPoint4, ...bottomPoint4, ...bottomPoint3],
        [...topPoint1, ...topPoint3, ...topPoint4, ...topPoint5]
      ];
    }
  },
  computed: {
    barFontWidthTotal() {
      return this.barFontWidth.reduce((pre, cur) => {
        pre += cur;
        return pre;
      }, 0);
    },
    dealseries0data() {
      return this.series0data;
    }
  },
  created() {
    const barArr = this.dealseries0data.reduce((pre, cur) => {
      pre.push(this.getBar(cur.value, this.finalDataCount));
      return pre;
    }, []);
    this.barArr = barArr;
    this.isLongText = this.dealseries0data.some(
      i => `${(i || {}).name}`.length > 40
    );
  }
};
</script>

<style lang="scss" scoped>
.custom-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top: 30px;
  &-item {
    display: flex;
    flex-wrap: wrap;
    &-block {
      padding: 20px 20px;
      width: 90px;
      & > svg {
        margin-bottom: 8px;
        cursor: pointer;
      }
      & > div {
        font-size: 12px;
        color: #323333;
        line-height: 18px;
        &.value {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
  }
  &.long {
    flex-wrap: wrap;
    .custom-bar-item {
      width: 100%;
      padding: 0px 50px;
      &-block {
        padding: 20px 15px;
        max-width: 195px;
      }
    }
  }
}
</style>
